import { render, staticRenderFns } from "./departmentAction.vue?vue&type=template&id=383e9fa8"
import script from "./departmentAction.vue?vue&type=script&lang=js"
export * from "./departmentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports